import { useInfiniteQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import queryKey from "../../../../enumerations/queryKey";
import { cancelWithdraw, getReceivedList, getWithdrawList, receiveReward } from "../service";

export const useGetWithdrawList = ({ params, options }) => {
  Object.keys(params).forEach((key) => {
    if (params[key] === null || params[key] === undefined || params[key] === "") {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useInfiniteQuery(
    [queryKey.WITHDRAW_LIST, ..._arrParams],
    ({ pageParam = 1 }) =>
      getWithdrawList({ params, page: pageParam }).then((res) => {
        return res.data.data;
      }),
    {
      ...options,
    },
  );
};

export const useGetReceivedList = ({ params, options }) => {
  Object.keys(params).forEach((key) => {
    if (params[key] === null || params[key] === undefined || params[key] === "") {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useInfiniteQuery(
    [queryKey.RECEIVED_LIST, ..._arrParams],
    ({ pageParam = 1 }) =>
      getReceivedList({ params, page: pageParam }).then((res) => {
        return res.data.data;
      }),
    {
      ...options,
    },
  );
};

export const useCancelWithdraw = () => {
  const cache = useQueryClient();
  return useMutation(({ id }) => cancelWithdraw(id).then((res) => res.data.data), {
    onSuccess: () => {
      cache.invalidateQueries([queryKey.WITHDRAW_LIST]);
    },
  });
};

export const useReceiveReward = () => {
  const cache = useQueryClient();
  return useMutation(({ id }) => receiveReward(id).then((res) => res.data.data), {
    onSuccess: () => {
      cache.invalidateQueries([queryKey.RECEIVED_LIST]);
    },
  });
};
